import { PreAuthorization } from '@gozoki/api-types';
import { gozokiApiWithAuth } from '../gozokiApi';

export const fetchPreAuthorizations = async (storeId: number) => {
    const response = await gozokiApiWithAuth.get<PreAuthorization[]>(
        `/stores/${storeId}/pre-authorizations`
    );
    return response.data;
};
